<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/package_rule/page" getKey="rows"
                   :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('baozhuangguizebianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baozhuangguizemingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain" :loading="yt.loading">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()" :loading="yt.loading">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,550,beforeShowDialog);" type="primary">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="edit(scope.row)">
              {{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
                       @click="yt.remove(scope.row,'/web/basic/package_rule/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template>
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('baozhuangguizebianma')" required>
              <el-input v-model="yt.editObj.code" v-if="yt.editObj.action == 'xinzeng'"></el-input>
              <el-input v-model="yt.editObj.code" disabled v-if="yt.editObj.action == 'bianji'"></el-input>
            </el-form-item>
            <el-form-item :label="$t('baozhuangguizemingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <p style="font-size: 16px;">{{$t('guize')}}{{$t('mingxi')}}</p>
            <div style="display:flex;padding: 20px 0;">
              <el-button size="mini" type="primary" :disabled="buttonDisabled" @click="up">{{$t('shangyi')}}</el-button>
              <el-button size="mini" type="primary" :disabled="buttonDisabled" @click="down">{{$t('xiayi')}}</el-button>
            </div>
            <el-form-item :label="$t('paixu')" label-width="125px">
            </el-form-item>
            <el-form-item :label="$t('danweimingcheng')" :required="true" label-width="110px">
            </el-form-item>
            <el-form-item :label="$t('shuliang')" :required="true" label-width="125px">
            </el-form-item>
            <el-form-item v-for="(item, index) in yt.editObj.itemList" :key="index" label-width="30px" size="mini">
              <div v-if="index===0" style="display: flex;">
                  <el-col style="width: 93px;">&nbsp;</el-col>
                  <el-col style="width: 85px;">{{index+1}}</el-col>
                  <el-col style="width: 172px;">{{item.unit}}</el-col>
                  <el-col style="width: 110px;">{{item.quantity}}</el-col>
              </div>
              <div v-else>
                <el-row>
                  <el-col :span="0.1">
                    <el-radio v-model="selected" :label="index+1" @input="selectRecord()">&nbsp;</el-radio>
                  </el-col>
                  <el-col :span="3">
                    <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)">
                    </el-button>
                  </el-col>
                  <el-col :span="0.8">&nbsp;</el-col>
                  <el-col :span="2">
                    {{index+1}}
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="4">
                    <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="item.unit" class="_input">
                    </yi_dictionary_select>
                  </el-col>
                  <el-col :span="3">&nbsp;</el-col>
                  <el-col :span="6">
                    <el-input v-model="item.quantity" class="_input" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
                    </el-input>
                  </el-col>

                </el-row>
              </div>
            </el-form-item>
            <el-form-item label-width="30px" size="mini" style="margin-top: 20px">
              <el-col style="padding-left: 28px">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem(yt.editObj.itemList.length)">
                  {{$t('zengjiayitiaoguizemingxi')}}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" v-if="yt.editObj.action == 'xinzeng'"
                     @click="yt.req('POST','/web/basic/package_rule/create',beforeSaveReq)" type="primary">
						{{$t('baocun')}}
					</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" v-if="yt.editObj.action == 'bianji'"
                     @click="yt.req('POST','/web/basic/package_rule/update',beforeSaveReq)" type="primary">
            {{$t('baocun')}}
          </el-button>
				</span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "web_base_package_rule_list",
  data(){
    return {
      columns: [
        { label: 'baozhuangguizebianma', prop: 'code', width: 280, },
        { label: 'baozhuangguizemingcheng', prop: 'name', width: 280, },
        { label: 'beizhu', prop: 'remark', width: 300, },
        { label: 'chuangjianren', prop: 'createByObject.nickname', width: 280, },
        { label: 'chuangjianshijian', prop: 'createTime',type: 'time', width: 300, },
        { label: 'caozuo', type: 'slot', width: 200, fixed: 'right', }
      ],
      selected: null,
      buttonDisabled: true,
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300)
  },
  methods:{
    beforeShowDialog(value){
      if (value.action == 'xinzeng') {
        value.itemList = [{
          sort: 1,
          unit: this.$t('morendanwei'),
          quantity: 1
        }];
      }
      return value;
    },
    edit(row){
      this.buttonDisabled = true;
      this.selected = null;
      this.yt.showEditDialog('bianji', row,550);
    },
    selectRecord(){
      this.buttonDisabled = false;
    },
    addItem(index) {
      this.yt.editObj.itemList.push({
        sort: '',
        unit: '',
        quantity: ''
      })
    },
    deleteItem(key) {
      this.yt.editObj.itemList = this.yt.editObj.itemList.filter((item, index) => {
        return index !== key
      })
    },
    up(){
      if(this.selected==2){
        return;
      }
      let selectedIndex = this.selected-1;
      let tempItem = this.yt.editObj.itemList[selectedIndex];
      this.yt.editObj.itemList[selectedIndex] = this.yt.editObj.itemList[selectedIndex-1];
      this.yt.editObj.itemList[selectedIndex-1] = tempItem;
      this.selected = selectedIndex;
    },
    down(){
      if(this.selected==this.yt.editObj.itemList.length){
        return;
      }
      let selectedIndex = this.selected-1;
      let tempItem = this.yt.editObj.itemList[selectedIndex];
      this.yt.editObj.itemList[selectedIndex] = this.yt.editObj.itemList[selectedIndex+1];
      this.yt.editObj.itemList[selectedIndex+1] = tempItem;
      this.selected = this.selected + 1;
    },
    beforeSaveReq(params){
      for (let i = 0; i < params.itemList.length; i++) {
        params.itemList[i].sort = i + 1;
      }
      params.itemList.shift();
      return params;
    }
  },
}
</script>

<style scoped="scoped">
._input /deep/ .el-input__inner {
  min-width: 0;
  width: 120px;
  text-align: center;
}
</style>